// src/pages/Landing.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function Landing() {
  return (
    <main style={{ paddingTop: 'var(--header-h)' }}>

      {/* ── HERO ─────────────────────────────────────────── */}
      <section style={s.hero} className="fade-up">
        <div style={s.eyebrow}>
          <span className="material-symbols-outlined" style={{ fontSize: 14 }}>favorite</span>
          Santé sociale
        </div>
        <h1 style={s.h1}>
          Se sentir moins seul,{' '}
          <em style={s.em}>près de chez soi.</em>
        </h1>
        <p style={s.desc}>
          Kindeo facilite des rencontres humaines simples et authentiques
          à proximité. Pas un réseau social, pas de likes — juste la vraie vie.
        </p>
        <div style={s.ctaRow}>
          <Link to="/inscription" className="k-button" style={{ width: 'auto', padding: '15px 32px' }}>
            Rejoindre Kindeo
          </Link>
          <Link to="/connexion" className="k-button-soft" style={{ width: 'auto', padding: '13px 24px' }}>
            Se connecter
          </Link>
        </div>
      </section>

      {/* ── PHOTO ────────────────────────────────────────── */}
      <div style={s.visual} className="fade-up">
        <div style={s.imgWrap}>
          <img
            src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=900&q=80"
            alt="Personnes discutant dans un café chaleureux"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div style={s.quote}>
          <p style={s.quoteText}>"Une vraie discussion, enfin."</p>
          <span style={s.quoteAuthor}>Marc, 42 ans · Lyon</span>
        </div>
      </div>

      {/* ── STATS ────────────────────────────────────────── */}
      

      {/* ── PROBLEM ──────────────────────────────────────── */}
      <section style={s.section}>
        <div style={s.tag}>
          <span className="material-symbols-outlined" style={{ fontSize: 13 }}>cloud_off</span>
          Le constat
        </div>
        <h2 style={s.h2}>La solitude moderne</h2>
        <p style={s.sectionText}>
          Nous sommes plus connectés que jamais, et pourtant le sentiment d'isolement
          n'a jamais été aussi fort. Nos quartiers sont remplis de visages familiers
          auxquels nous n'osons plus parler.
        </p>
        <div style={s.pullquote}>
          <p style={s.pullquoteText}>
            "On scrolle des vies parfaites au lieu de vivre la nôtre, juste à côté de chez nous."
          </p>
        </div>
      </section>

      {/* ── HOW IT WORKS ─────────────────────────────────── */}
      <section style={{ ...s.section, paddingTop: 0 }}>
        <div style={s.tag}>
          <span className="material-symbols-outlined" style={{ fontSize: 13 }}>route</span>
          Comment ça marche
        </div>
        <h2 style={s.h2}>Simple par design</h2>
        <div style={s.steps}>
          {[
            { n: '1', title: 'Créer son profil',        desc: 'En 2 minutes. Pas d\'algorithme, juste vos envies.' },
            { n: '2', title: 'Découvrir autour de soi', desc: 'Voyez qui est proche et disponible pour échanger.' },
            { n: '3', title: 'Proposer un moment',      desc: 'Un café, une balade — dans un lieu public.' },
          ].map(step => (
            <div key={step.n} style={s.step}>
              <div style={s.stepNum}>{step.n}</div>
              <div>
                <h3 style={s.stepTitle}>{step.title}</h3>
                <p style={s.stepDesc}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── ETHICS ───────────────────────────────────────── */}
      <section style={{ ...s.section, paddingTop: 0 }}>
        <div style={s.tag}>
          <span className="material-symbols-outlined" style={{ fontSize: 13 }}>verified_user</span>
          Notre éthique
        </div>
        <h2 style={s.h2}>Un espace différent</h2>
        <div style={s.ethicsGrid}>
          {[
            { icon: 'visibility_off', title: 'Pas de likes',      desc: 'Aucun compteur. L\'authenticité d\'abord.' },
            { icon: 'timer_off',      title: 'Non-addictif',       desc: 'Pas de scroll infini. Kindeo se ferme une fois le lien créé.' },
            { icon: 'security',       title: 'Données protégées',  desc: 'Votre vie privée n\'est pas notre produit.' },
            { icon: 'place',          title: 'Local avant tout',   desc: 'Priorité à la proximité, des rencontres possibles.' },
          ].map(item => (
            <div key={item.title} style={s.ethicsItem}>
              <div style={s.ethicsIcon}>
                <span className="material-symbols-outlined">{item.icon}</span>
              </div>
              <h4 style={s.ethicsTitle}>{item.title}</h4>
              <p style={s.ethicsDesc}>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── FINAL CTA ────────────────────────────────────── */}
      <div style={s.finalCta}>
        <h2 style={s.finalH2}>Prêt à retrouver l'humain ?</h2>
        <p style={s.finalDesc}>Rejoignez des milliers de personnes qui recréent du lien.</p>
        <Link to="/inscription" className="k-button"
          style={{ width: 'auto', display: 'inline-block', padding: '15px 36px', background: '#fff', color: 'var(--c-primary)' }}>
          Rejoindre Kindeo
        </Link>
      </div>

    </main>
  );
}

const s = {
  hero:       { padding: '72px 24px 60px', maxWidth: 680, margin: '0 auto' },
  eyebrow:    { display: 'inline-flex', alignItems: 'center', gap: 6, background: 'var(--c-accent-lt)', color: 'var(--c-accent)', fontFamily: 'Manrope,sans-serif', fontSize: 11, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', padding: '6px 14px', borderRadius: 'var(--radius-pill)', marginBottom: 28 },
  h1:         { fontFamily: 'Manrope,sans-serif', fontSize: 'clamp(36px,8vw,56px)', fontWeight: 800, color: 'var(--c-primary)', lineHeight: 1.08, letterSpacing: '-1.5px', marginBottom: 22 },
  em:         { fontFamily: 'Lora,serif', fontStyle: 'italic', fontWeight: 400, color: 'var(--c-accent)' },
  desc:       { fontSize: 17, color: 'var(--c-text-2)', lineHeight: 1.7, maxWidth: 520, marginBottom: 36 },
  ctaRow:     { display: 'flex', gap: 12, flexWrap: 'wrap' },
  visual:     { margin: '40px 24px 0', maxWidth: 680, marginLeft: 'auto', marginRight: 'auto', position: 'relative' },
  imgWrap:    { borderRadius: 'var(--radius-xl)', overflow: 'hidden', aspectRatio: '16/9', background: 'var(--c-surface-2)', boxShadow: 'var(--shadow-lg)' },
  quote:      { position: 'absolute', bottom: -20, right: 20, background: 'var(--c-surface)', borderRadius: 'var(--radius-lg)', padding: '14px 18px', boxShadow: 'var(--shadow-md)', border: '1px solid var(--c-border)', maxWidth: 240 },
  quoteText:  { fontStyle: 'italic', fontSize: 13, color: 'var(--c-primary)', lineHeight: 1.5, marginBottom: 6 },
  quoteAuthor:{ fontFamily: 'Manrope,sans-serif', fontSize: 10, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: 'var(--c-text-3)' },
  stats:      { display: 'flex', margin: '56px 24px 0', maxWidth: 680, marginLeft: 'auto', marginRight: 'auto', background: 'var(--c-surface)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--c-border)', overflow: 'hidden', boxShadow: 'var(--shadow-sm)' },
  stat:       { flex: 1, padding: '22px 16px', textAlign: 'center', borderRight: '1px solid var(--c-border)' },
  statNum:    { fontFamily: 'Manrope,sans-serif', fontSize: 26, fontWeight: 800, color: 'var(--c-primary)', letterSpacing: '-0.5px' },
  statLabel:  { fontFamily: 'Manrope,sans-serif', fontSize: 11, fontWeight: 500, color: 'var(--c-text-3)', marginTop: 3 },
  section:    { padding: '72px 24px', maxWidth: 680, margin: '0 auto' },
  tag:        { display: 'inline-flex', alignItems: 'center', gap: 6, background: 'var(--c-primary-lt)', color: 'var(--c-primary)', fontFamily: 'Manrope,sans-serif', fontSize: 11, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', padding: '6px 14px', borderRadius: 'var(--radius-pill)', marginBottom: 20 },
  h2:         { fontFamily: 'Manrope,sans-serif', fontSize: 'clamp(26px,5vw,36px)', fontWeight: 800, color: 'var(--c-primary)', letterSpacing: '-0.8px', lineHeight: 1.15, marginBottom: 16 },
  sectionText:{ fontSize: 16, color: 'var(--c-text-2)', lineHeight: 1.75, marginBottom: 24 },
  pullquote:  { background: 'var(--c-surface)', borderLeft: '3px solid var(--c-accent)', borderRadius: '0 var(--radius-md) var(--radius-md) 0', padding: '20px 22px', boxShadow: 'var(--shadow-sm)' },
  pullquoteText: { fontStyle: 'italic', fontSize: 17, color: 'var(--c-text)', lineHeight: 1.6 },
  steps:      { display: 'flex', flexDirection: 'column', gap: 16, marginTop: 28 },
  step:       { display: 'flex', alignItems: 'flex-start', gap: 18, background: 'var(--c-surface)', borderRadius: 'var(--radius-lg)', padding: '20px', border: '1px solid var(--c-border)', boxShadow: 'var(--shadow-sm)' },
  stepNum:    { flexShrink: 0, width: 44, height: 44, borderRadius: 'var(--radius-pill)', background: 'var(--c-primary)', color: '#fff', fontFamily: 'Manrope,sans-serif', fontSize: 18, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  stepTitle:  { fontFamily: 'Manrope,sans-serif', fontSize: 16, fontWeight: 700, color: 'var(--c-primary)', marginBottom: 5 },
  stepDesc:   { fontSize: 14, color: 'var(--c-text-2)', lineHeight: 1.6 },
  ethicsGrid: { display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 14, marginTop: 28 },
  ethicsItem: { background: 'var(--c-surface)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--c-border)', padding: '20px 18px', boxShadow: 'var(--shadow-sm)' },
  ethicsIcon: { width: 40, height: 40, borderRadius: 'var(--radius-md)', background: 'var(--c-primary-lt)', color: 'var(--c-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 },
  ethicsTitle:{ fontFamily: 'Manrope,sans-serif', fontSize: 14, fontWeight: 700, color: 'var(--c-text)', marginBottom: 6 },
  ethicsDesc: { fontSize: 13, color: 'var(--c-text-2)', lineHeight: 1.55 },
  finalCta:   { margin: '0 24px 60px', maxWidth: 680, marginLeft: 'auto', marginRight: 'auto', background: 'var(--c-primary)', borderRadius: 'var(--radius-xl)', padding: '48px 32px', textAlign: 'center' },
  finalH2:    { fontFamily: 'Manrope,sans-serif', fontSize: 'clamp(24px,5vw,32px)', fontWeight: 800, color: '#fff', letterSpacing: '-0.5px', marginBottom: 12 },
  finalDesc:  { color: 'rgba(255,255,255,.75)', fontSize: 15, marginBottom: 28, lineHeight: 1.6 },
};
